import request from '@/utils/request'

// 获取题目列表
export function getQuestionList(params) {
  return request({
    url: '/api/question/list',
    method: 'get',
    params
  })
}

// 获取赛事题目列表
export function getQuestions(gameCode) {
  return request({
    url: `/api/game/questions/${gameCode}`,
    method: 'get'
  })
}

// 获取题目复盘信息
export function getQuestionReplay(questionCode) {
  return request({
    url: `/api/question/${questionCode}/replay`,
    method: 'get'
  })
}

// 更新题目收藏状态
export function updateQuestionCollect(questionCode, isCollect) {
  return request({
    url: `/api/question/${questionCode}/collect`,
    method: 'put',
    data: {
      is_collect: isCollect
    }
  })
}

// 获取随机未订正题目
export function getRandomUnfixQuestion() {
  return request({
    url: '/api/question/random-unfix',
    method: 'get'
  })
}

// 更新题目挂起状态
export function updateQuestionPending(questionCode, isPending) {
  return request({
    url: `/api/question/${questionCode}/pending`,
    method: 'put',
    data: {
      is_pending: isPending
    }
  })
} 